module.exports = __webpack_public_path__ + "img/winwheel-outside.27f436af.png";